/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "../mail-send/mail-send.component.ngfactory";
import * as i2 from "../mail-send/mail-send.component";
import * as i3 from "../../services/api/dynamic-field.service";
import * as i4 from "../../services/api/mail-api.service";
import * as i5 from "../../services/auth.service";
import * as i6 from "../../services/api/file-api.service";
import * as i7 from "../../services/api/job-api.service";
import * as i8 from "../../services/api/progress-api.service";
import * as i9 from "../../services/api/company-api.service";
import * as i10 from "../../services/api/user-api.service";
import * as i11 from "../../pipes/safe-date.pipe";
import * as i12 from "./mail-send-flow-dialog.component";
var styles_MailSendFlowDialogComponent = [];
var RenderType_MailSendFlowDialogComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_MailSendFlowDialogComponent, data: {} });
export { RenderType_MailSendFlowDialogComponent as RenderType_MailSendFlowDialogComponent };
export function View_MailSendFlowDialogComponent_0(_l) { return i0.ɵvid(0, [i0.ɵqud(402653184, 1, { mailSend: 0 }), (_l()(), i0.ɵeld(1, 0, null, null, 1, "ag-mail-send", [], null, [[null, "closed"], [null, "showPopup"], [null, "sent"]], function (_v, en, $event) { var ad = true; var _co = _v.component; if (("closed" === en)) {
        var pd_0 = (_co.close() !== false);
        ad = (pd_0 && ad);
    } if (("showPopup" === en)) {
        var pd_1 = (_co.openPopup($event) !== false);
        ad = (pd_1 && ad);
    } if (("sent" === en)) {
        var pd_2 = (_co.sent.emit() !== false);
        ad = (pd_2 && ad);
    } return ad; }, i1.View_MailSendComponent_0, i1.RenderType_MailSendComponent)), i0.ɵdid(2, 114688, [[1, 4], ["mailSend", 4]], 0, i2.MailSendComponent, [i3.DynamicFieldService, i4.MailApiService, i5.AuthService, i6.FileApiService, i7.JobApiService, i8.ProgressApiService, i9.CompanyApiService, i10.UserApiService, i11.SafeDatePipe], null, { showPopup: "showPopup", closed: "closed", sent: "sent" })], function (_ck, _v) { _ck(_v, 2, 0); }, null); }
export function View_MailSendFlowDialogComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "ag-mail-send-flow-dialog", [], null, null, null, View_MailSendFlowDialogComponent_0, RenderType_MailSendFlowDialogComponent)), i0.ɵdid(1, 245760, null, 0, i12.MailSendFlowDialogComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var MailSendFlowDialogComponentNgFactory = i0.ɵccf("ag-mail-send-flow-dialog", i12.MailSendFlowDialogComponent, View_MailSendFlowDialogComponent_Host_0, {}, { sent: "sent", closed: "closed" }, []);
export { MailSendFlowDialogComponentNgFactory as MailSendFlowDialogComponentNgFactory };
